



































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { EnquiryProduct } from '@/models/enquiry-product';
import { EnquiryApi } from '@/api/enquiry-api';
import { CostCentreApi } from '@/api/cost-centre-api';
import { Enquiry } from '@/models/enquiry';
import { isFileTypeValid, isFileSizeValue } from '@/file-validator';
import { EnquiryComment } from '@/models/enquiry-comment';
import { Forbidden } from '@/models/forbidden-error';
import { NotFound } from '@/models/not-found-error';
import { User } from '@/models/user';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { CostCentre } from '@/models/cost-centre';
import { CustomerApi } from '@/api/customer-api';
import { namespace } from 'vuex-class';
import { Customer } from '@/models/customer';
import CostcentreSelector from '@/components/costcentre-selector.vue';

const userModule = namespace('user');
const costCentreModule = namespace('costCentre');
const customerModule = namespace('customer');
const enquiryApi = new EnquiryApi();
const customerApi = new CustomerApi();
const costCentreApi = new CostCentreApi();

@Component({
    components: {
        ValidationProvider,
        ValidationObserver,
        CostcentreSelector,
    },
})
export default class EnquiryForm extends Vue {
    @userModule.Getter('currentCustomer') public currentCustomer: Customer | null;
    @costCentreModule.Getter('costCentres') public costCentres: Array<CostCentre>;
    @customerModule.Getter('contactNames') public userNames: Array<string>;
    private keyIndex: number = 0;
    public isLoading: boolean = true;
    public contactName: string | null = null;
    public costCentreId: string | null = null;
    public contactTelephone: string | null = null;
    public equipmentOrMachinary: string | null = null;
    public description: string | null = null;
    public products: Array<EnquiryProduct> = new Array<EnquiryProduct>(...[
        { key: this.keyIndex, productNumber: null, description: null, quantity: 0, supplier: null, partNumber: null, price: null }
    ]);
    public documents: Array<File> = new Array<File>();
    public comments: Array<EnquiryComment> = new Array<EnquiryComment>();
    public commentValue: string | null = null;

    @Watch('currentCustomer')
    public async onCustomerChanged(value: Customer): Promise<void> {
        await this.$store.dispatch('costCentre/fetchAsync');
        await this.$store.dispatch('customer/fetchUsersAsync', this.currentCustomer!.id!);
    }
    public async load(): Promise<void> {
        await this.$store.dispatch('costCentre/fetchAsync');
        await this.$store.dispatch('customer/fetchUsersAsync', this.currentCustomer!.id!);
    }
    public async mounted(): Promise<void> {
        this.isLoading = true;
        await this.load();
        this.isLoading = false;
    }

    public get isValid(): boolean {
        return this.contactName != null && this.contactName.length > 0 &&
            this.contactTelephone != null && this.contactTelephone.length > 0 &&
            this.equipmentOrMachinary != null && this.equipmentOrMachinary.length > 0 &&
            this.description != null && this.description.length > 0 &&
            this.products != null && this.products.length > 0;
    }

    public addProduct(): void {
        this.products.push({ key: ++this.keyIndex, productNumber: null, description: null, quantity: 0, supplier: null, partNumber: null, price: null });
    }
    public removeProduct(index: number): void {
        this.products.splice(index, 1);
    }
    public addDocument(): void {
        (this.$refs.files as HTMLInputElement).click();
    }
    public fileUploadChanged(): void {
        const files = (this.$refs.files as HTMLInputElement).files;

        if (files == null) {
            return;
        }

        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < files.length; i++) {
            if (isFileTypeValid(files[i]) && isFileSizeValue(files[i])) {
                this.documents.push(files[i]);
            }
        }

        (this.$refs.files as HTMLInputElement).value = '';
    }
    public removeFile(index: number): void {
        this.documents.splice(index, 1);
    }
    public addComment(): void {
        if (this.commentValue != null) {
            const comment: EnquiryComment = {
                value: this.commentValue,
            };

            this.comments.push(comment);
            this.ClearCommentBox();
        }
    }
    public removeComment(index: number): void {
        this.comments.splice(index, 1);
    }
    public onCostCentreSelected(costCentreId: string | null): void {
        this.costCentreId = costCentreId;
    }
    public async submitEnquiry(): Promise<void> {
        const enquiry: Enquiry = {
            id: null,
            status: 0,
            contactName: this.contactName,
            costCentreId: this.costCentreId,
            contactTelephone: this.contactTelephone,
            equipmentOrMachinary: this.equipmentOrMachinary,
            description: this.description,
            products: this.products,
        };

        const id = await enquiryApi.createAsync(enquiry);

        const fileUploads: Array<Promise<void>> = [];

        for (const document of this.documents) {
            fileUploads.push(enquiryApi.createDocumentAsync(id, document));
        }

        await Promise.all(fileUploads);

        const comments: Array<Promise<void>> = [];

        for (const comment of this.comments) {
            comments.push(enquiryApi.createCommentAsync(id, comment));
        }

        await Promise.all(comments);

        this.$emit('enquiry-saved', id);
    }

    public ClearCommentBox(): void {
        this.commentValue = null;
    }

    private sortCostcentres(parentCostcentre: CostCentre): void {
        const childCostcentres = this.costCentres.filter((cc) => cc.parentId === parentCostcentre.id);

        parentCostcentre.children = childCostcentres;

        if (childCostcentres.length === 0) {
            return;
        }

        parentCostcentre.children.forEach((c) => this.sortCostcentres(c));
    }

    public get topLevelCostcentres() : Array<CostCentre> {
        let parentCostCentres = this.costCentres.filter((cc) => cc.parentId === null);

        parentCostCentres.forEach(pcc => this.sortCostcentres(pcc));

        return parentCostCentres;
    }
}
